import * as React from "react";
import { Navigate, useLocation } from "react-router";
import { getCloudMetadata, getCurrentUser } from "./getCurrentUser";

const RETURN_HASH_KEY = "labelmaster.returnHash";

export function persistReturnHash(hashPath: string) {
  try {
    sessionStorage.setItem(RETURN_HASH_KEY, hashPath);
  } catch {
    // ignore
  }
}

export function consumeReturnHash(): string | null {
  try {
    const value = sessionStorage.getItem(RETURN_HASH_KEY);
    if (value) {
      sessionStorage.removeItem(RETURN_HASH_KEY);
      return value;
    }
  } catch {
    // ignore
  }
  return null;
}

export function redirectToSignIn(returnHashPath?: string) {
  const metadata = getCloudMetadata();
  if (returnHashPath) {
    persistReturnHash(returnHashPath);
  }
  if (metadata?.SignInUrl) {
    window.location.href = metadata.SignInUrl;
  }
}

type GuardProps = {
  children: React.ReactNode;
};

export function RequireAuth({ children }: GuardProps) {
  const location = useLocation();
  const user = getCurrentUser();

  React.useEffect(() => {
    if (!user) {
      redirectToSignIn(location.pathname + location.search);
    }
  }, [user, location.pathname, location.search]);

  if (!user) {
    return <p>Redirecting to sign in…</p>;
  }

  return <>{children}</>;
}

export function RequireAdmin({ children }: GuardProps) {
  const location = useLocation();
  const user = getCurrentUser();

  React.useEffect(() => {
    if (!user) {
      redirectToSignIn(location.pathname + location.search);
    }
  }, [user, location.pathname, location.search]);

  if (!user) {
    return <p>Redirecting to sign in…</p>;
  }

  if (!user.IsAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
